/**
 * TBM 진행자 QR 주소
 * - QR 값: {모바일 웹}/tbm/join/{입장 토큰}
 * - SafeOn 앱 스캐너: 토큰만 꺼내 기존 회원 참석(saveTbmNewU2)
 * - 일반 카메라: 모바일 웹 게스트 참석 화면(/tbm/join/:token)
 * 모바일 웹 주소는 외부 참여자 서명 링크(M_ExternalSign)와 같은 도메인
 */
const JOIN_PATH = '/tbm/join/';

const DEFAULT_JOIN_BASE_URL = {
  development: 'https://devmobilelv.com',
  production: 'https://mobile.safeoncorp.com',
};

/** REACT_APP_TBM_JOIN_URL이 있으면 우선, 없으면 빌드 환경(REACT_APP_ENV)별 기본값 */
export const GetTbmJoinBaseUrl = () =>
  String(
    process.env.REACT_APP_TBM_JOIN_URL ||
      DEFAULT_JOIN_BASE_URL[process.env.REACT_APP_ENV] ||
      DEFAULT_JOIN_BASE_URL.production
  )
    .trim()
    .replace(/\/+$/, '');

export const BuildTbmJoinUrl = (joinToken) =>
  joinToken ? `${GetTbmJoinBaseUrl()}${JOIN_PATH}${joinToken}` : '';

/** 입장 토큰 형식 (서버 TbmJoinToken: 32자리 16진수) */
export const IsTbmJoinToken = (value) =>
  /^[0-9a-f]{32}$/i.test(String(value ?? ''));

/**
 * 앱 스캐너용: QR 원문 → saveTbmNewU2 SessionCd 값
 * - 구버전 QR(세션번호 숫자)은 그대로, URL·토큰 QR은 입장 토큰
 * - TBM QR이 아니면 ''
 */
export const ParseTbmQrValue = (raw) => {
  const text = String(raw ?? '').trim();
  if (!text) return '';
  if (/^\d+$/.test(text)) return text;

  const index = text.indexOf(JOIN_PATH);
  const candidate = index >= 0 ? text.slice(index + JOIN_PATH.length) : text;
  const token = candidate.split(/[/?#]/)[0];
  return IsTbmJoinToken(token) ? token.toLowerCase() : '';
};
